import React, { useState, useEffect } from 'react';

import FetchApi from './../../../customhooks/Functionapi';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment/moment.js';
import './viewdocument.scss';

// สถานะของแต่ละขั้น: อนุมัติแล้ว / รับงานแล้วกำลังดำเนินการ / ยังไม่ถึงคิว
function getStepState(item) {
  if (item.activerecieved == 1 && item.active == 1) {
    return { key: 'done', label: 'อนุมัติแล้ว', color: '#43a047', bg: '#e8f5e9', border: '#c8e6c9', icon: <CheckRoundedIcon sx={{ fontSize: 18 }} /> };
  }
  if (item.activerecieved == 1) {
    return { key: 'progress', label: 'กำลังดำเนินการ', color: '#ef6c00', bg: '#fff3e0', border: '#ffe0b2', ring: 'rgba(239,108,0,0.15)', icon: <HourglassTopRoundedIcon sx={{ fontSize: 17 }} /> };
  }
  return { key: 'waiting', label: 'รอดำเนินการ', color: '#90a4ae', bg: '#f5f7f8', border: '#e3e6ea', icon: <PersonOutlineRoundedIcon sx={{ fontSize: 18 }} /> };
}

export default function StepViewProcess(props) {
  const FetchApis = new FetchApi();
  const [datalist, setDatalist] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [typestatusflow, setTypestatusflow] = useState([{
    nameStatus: '',
    userbyflow: '',
    departments: '',
    stateflow: '',
    Startdatetime: '',
    Enddatetime: '',
    statusType: '',
    activerecieved: '',
    active: ''
  }]);


  useEffect(() => {

    flowlistStep()
  }, [])



  async function flowlistStep() {

    await FetchApis.FethcGet(`/flowrunsystem/flowSteplistByJourId/${props.jourID}`).then(res => {
      if (res) {
        // console.log(res.data);
        setDatalist(res.data)
      }
    })

  }
  const handleClickOpen = (nameStatus, userbyflow, departments, stateflow, Startdatetime, Enddatetime, statusType, activerecieved, active) => {

    // HistoryByUser(jourID, statflow, UserId)
    setTypestatusflow({
      ...typestatusflow,
      nameStatus: nameStatus,
      userbyflow: userbyflow,
      departments: departments,
      stateflow: stateflow,
      Startdatetime: Startdatetime,
      Enddatetime: Enddatetime,
      statusType: statusType,
      activerecieved: activerecieved,
      active: active
    })
    setOpen(true);

  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', rowGap: 1.5, py: 1 }}>
      {datalist.map((item, indix) => {
        const step = getStepState(item);
        const prevDone = indix > 0 && getStepState(datalist[indix - 1]).key === 'done';
        return (
          <Box key={indix} sx={{ display: 'flex', alignItems: 'center' }}>
            {indix > 0 && (
              <Box sx={{
                width: 36, mx: 0.75,
                borderTop: prevDone ? '3px solid #43a047' : '3px dashed #cfd8dc',
                borderRadius: 2,
              }} />
            )}

            <Tooltip title={`ลำดับ ${item.stateflow}${item.departments ? ` · ${item.departments}` : ''} · ${step.label}`} arrow>
              <Box
                onClick={() => handleClickOpen(item.nameStatus, item.userbyflow, item.departments, item.stateflow, item.Startdatetime, item.Enddatetime, item.statusType, item.activerecieved, item.active)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 1,
                  pl: 0.5, pr: 1.75, py: 0.5,
                  borderRadius: 999,
                  bgcolor: step.bg,
                  border: `1px solid ${step.border}`,
                  cursor: 'pointer',
                  transition: 'transform .15s, box-shadow .15s',
                  boxShadow: step.key === 'progress' ? `0 0 0 3px ${step.ring}` : 'none',
                  '&:hover': { transform: 'translateY(-1px)', boxShadow: '0 4px 10px rgba(0,0,0,0.12)' },
                }}
              >
                <Box sx={{
                  width: 28, height: 28, borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  bgcolor: step.color, color: '#fff', flexShrink: 0,
                }}>
                  {step.icon}
                </Box>
                <Box sx={{ lineHeight: 1.15 }}>
                  <Box sx={{ fontSize: 13, fontWeight: 600, color: '#263238', whiteSpace: 'nowrap' }}>
                    คุณ {item.userbyflow}
                  </Box>
                  <Box sx={{ fontSize: 11, color: step.color, fontWeight: 500, whiteSpace: 'nowrap' }}>
                    {step.label}
                  </Box>
                </Box>
              </Box>
            </Tooltip>
          </Box>
        );
      })}

      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"ประวัติอนุมัติ"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">

              <div style={{ flexDirection: 'column', justifyContent: 'space-between', display: 'flex', width: 500 }}>
                <div>
                  <label style={{ fontWeight: '800', fontSize: 20 }}>ผู้อนุมัติ : {typestatusflow.userbyflow}</label>
                </div>
                <br />
                <div>
                  <label>ลำดับอนุมัติ : {typestatusflow.stateflow}</label>
                </div>
                <div>
                  <label>แผนก :{typestatusflow.departments}</label>
                </div>
                <div>
                  <label>สถานะ : {typestatusflow.nameStatus}</label>
                </div>
                <br />
                <hr></hr>
                {typestatusflow.activerecieved == '1' &&
                  <div>
                    {typestatusflow.statusType == '100' ? <label style={{ color: '#1C08CF' }}>วันที่สร้าง :{moment(typestatusflow.Startdatetime).format('DD/MM/yyyy   HH:mm:ss')}</label> : <label style={{ color: '#1C08CF' }}>วันที่รับ :{moment(typestatusflow.Startdatetime).format('DD/MM/yyyy   HH:mm:ss')}</label>}
                  </div>}
                {typestatusflow.active == '1' &&
                  <div>
                    <label style={{ color: 'green' }}>วันที่อนุมัติ :{moment(typestatusflow.Enddatetime).format('DD/MM/yyyy   HH:mm:ss')}</label>
                  </div>}
              </div>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>ปิด</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

    </Box>
  );
}